/**
 * En este archivo se colocan las rutas que tendrá la aplicación, estas automáticamente colocarán
 * el componente que definas en donde lo coloques.
 *
 * ## Opciones
 *
 * - `Component`
 *   Acá se coloca el componente que renderizará la ruta. Ej: <CustomersContainer />
 *
 * - `hidden`
 *   Esta opción es opcional y sirve para ocultar una ruta del menú.
 *
 * - `Icon`
 *   Esta opción es opcional y también es un componente de React que incluye el icono que tendrá
 *   en el menú lateral; es opcional debido a que algunas rutas no se colocarán en el menú.
 *
 * - `id`
 *   Esta opción es opcional y sirve para colocar el id del menú que está en autorizaciones,
 *   desde acá se obtendrá el nombre que saldrá en el menú y para cuáles usuarios estará visible.
 *
 * - `requireLogged`
 *   Esta opción cuando es `true` requiere que el usuario haya iniciado sesión antes de mostrarle el
 *   componente. Si no ha iniciado sesión y es requerido, la ruta no existirá en el enrutador y se
 *   mostrará la vista del 404 (Vista de no autorizado).
 *
 * - `url`
 *   Acá se coloca la ruta donde se renderizará el componente, esta debe estar dentro de `paths.constant.ts`.
 */

import { NoAuthorized } from '@features/common';
import { CustomersContainer } from '@features/customers';
import type Route from '@interfaces/route.interface';
import { Groups } from '@mui/icons-material';
import { CUSTOMERS_PATH, GENERATE_GUIDE, GROUPS_PATH, USERS_PATH } from './paths.constant';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PersonIcon from '@mui/icons-material/Person';
import BusinessGroupsContainer from '@features/customers/containers/BusinessGroupsContainer';
import UsersContainer from '@features/customers/containers/UsersContainer';
import GenerateGuideContainer from '@features/generateGuide/containers/GenerateGuideContainer';

const routes: Route[] = [
	{
		Component: CustomersContainer,
		Icon: <Groups />,
		id: 'gestionar_clientes_',
		requireLogged: true,
		url: CUSTOMERS_PATH,
	},
	{
		Component: BusinessGroupsContainer,
		Icon: <GroupAddIcon />,
		id: 'gestionar_grupos_empresariales_',
		requireLogged: true,
		url: GROUPS_PATH,
	},
	{
		Component: UsersContainer,
		Icon: <PersonIcon />,
		id: 'gestionar_usuarios_',
		requireLogged: true,
		url: USERS_PATH,
	},
	{
		Component: GenerateGuideContainer,
		Icon: <PersonIcon />,
		id: 'generar_guia_',
		requireLogged: true,
		url: GENERATE_GUIDE,
	},
	{
		Component: NoAuthorized,
		hidden: true,
		requireLogged: false,
		url: '*',
	},
];

export default routes;
